import { Link } from 'react-router-dom';
import { History, ShieldCheck, Landmark } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useFondoResumen } from '@/features/fondo-reserva/api';
import { FondoHero } from '@/features/fondo-reserva/fondo-hero';
import { RegistrarMovimientoForm } from '@/features/fondo-reserva/registrar-movimiento-form';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/empty-state';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function FondoReservaRoute() {
  const { condoId, rol } = useCondoContext();
  const { data, isLoading } = useFondoResumen(condoId);

  const isAdmin = rol === 'admin' || rol === 'super_admin';

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Finanzas"
        title="Fondo de reserva"
        subtitle="Saldo, movimientos y verificacion de integridad del fondo de reserva. Ley 21.442 Art. 7."
        action={
          <div className="flex gap-2">
            <Button variant="outline" asChild>
              <Link to={`/app/condominios/${condoId}/fondo-reserva/verificar`}>
                <ShieldCheck className="h-4 w-4" />
                Verificar integridad
              </Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to={`/app/condominios/${condoId}/fondo-reserva/movimientos`}>
                <History className="h-4 w-4" />
                Ver historial
              </Link>
            </Button>
          </div>
        }
      />

      <div className="space-y-8">
        <FondoHero data={data} isLoading={isLoading} />

        {!isLoading && !data?.ultimoMovimiento && (
          <EmptyState
            icon={<Landmark className="h-5 w-5" />}
            title="Sin movimientos en el fondo de reserva"
            description="El fondo de reserva se alimenta automaticamente al emitir gastos comunes. Tambien puedes registrar aportes extraordinarios o gastos autorizados."
          />
        )}

        {isAdmin && <RegistrarMovimientoForm condoId={condoId} />}
      </div>
    </PageContainer>
  );
}
